import React, { useState } from "react";
import { useLanguage } from "../../Translations/LenguageContext";
import NewApi from "../API/NewApi";
import CanvasAnimation from "../../Components/CanvasItems";

const EmptyViewOpenModal = ({ fetchRecords, title, subtitle, item }) => {
    const { t } = useLanguage()
    const [openModalApi, setOpenModalApi] = useState(false)
    const [openModalConnector, setOpenModalConnector] = useState(false)

    const OpenSelectedModal = () => {
        console.log(item)
        if (item == "api"){
            setOpenModalApi(true)
        }else if(item == "connector"){
            setOpenModalConnector(true)
        }
    }


    return (
        <div className="empty_cont">
            <div className="icon_cont">
                <p className="icon_cont_title fade-in">{title}</p>
                <p className="icon_cont_subtitle fade-in">{subtitle}</p>

                {item != "" && (
                     <div className="canvas_anim_empty_cont fade-in">
                        <CanvasAnimation type={item}/>
                    </div>
                )}
            </div>
            <div className="btn_cont">
                <button className="connect_email_btn fade-in" onClick={OpenSelectedModal}><i className="fa-solid fa-plus"></i> {t.create}</button>
            </div>
            <NewApi
                show={openModalApi}
                handleClose={() => setOpenModalApi(false)}
                fetchRecords={fetchRecords}
            />
        </div>
    )
}

export default EmptyViewOpenModal